import { toast } from 'react-toastify';
import API from '../apiClient';
export const userListByOrganization = (entity, includeInactive = false) => {
    return new Promise((resolve) => {
      const queryParam = includeInactive ? '?include_inactive=true' : '';
      API.get(`/users/userListByOrganization/${encodeURIComponent(entity)}${queryParam}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          // toast.error("Something went wrong")
          console.log(error)
        }); 
    });
  };

  export const gerUsersDataByOrg = (entity,url) => {
    return new Promise((resolve) => {
      API.get(`/users/userListByOrganization/${encodeURIComponent(entity)}?${url}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          // toast.error("Something went wrong")
          console.log(error)
        }); 
    });
  };
